import React from "react";
import {
  Checkbox,
  Dialog,
  FlatButton,
  MenuItem,
  SelectField,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from "material-ui";
import { FormattedMessage, injectIntl } from "react-intl";
import Clear from "material-ui/svg-icons/content/clear";
import ActionSearch from "material-ui/svg-icons/action/search";
import RoleSelect from "./RoleSelect";
import ConfirmRole from "./ConfirmRole";
import { TableRowContent } from "../EmailAddressBook/EmailAddressBookTable";
import { sortAlphabetically, sortByJapaneseSyllabary, sortNumerically } from "../../routes/EmailAddressBook/reducer";

const tdStyle = {
  borderRight: "1px solid #b8b8b8",
  textAlign: "center",
  whiteSpace: "pre-wrap",
  overflow: "visible",
  padding: "4px 8px",
  color: "#657285",
  wordBreak: "break-all",
};

const GroupSelect = (props) => {
  return (
    <SelectField
      floatingLabelText={<FormattedMessage id="emailAddressBook.group" />}
      // floatingLabelStyle={{display: props.selectedGroup ? 'none' : 'block'}}
      style={{
        height: "48px",
        marginRight: "16px",
        width: "130px",
        marginTop: props.isFull ? "-10px" : "0",
      }}
      floatingLabelStyle={{
        top: "16px",
        color: "#fff",
        fontSize: "14px",
        display: props.selectedGroup ? "none" : "block",
      }}
      hintStyle={{
        display: "none",
      }}
      labelStyle={{
        color: "#fff",
        fontSize: "14px",
        top: "0px",
      }}
      menuStyle={{
        margin: 0,
        overflow: "hidden",
      }}
      className="group-select"
      listStyle={{
        overflow: "hidden",
      }}
      value={props.selectedGroup}
      onChange={props.handleGroupSelect}
    >
      <MenuItem
        value="group"
        primaryText={<FormattedMessage id="emailAddressBook.group" />}
      />
      {props.groups.map((g) => {
        return <MenuItem value={g.id} primaryText={g.name} />;
      })}
    </SelectField>
  );
};

const SearchBar = (props) => {
  return (
    <div
      style={{
        border: "1px solid #6B7c93",
        position: "relative",
        height: "36px",
        display: "flex",
        alignItems: "center",
        maxWidth: props.isFull ? "unset" : "250px",
        minWidth: props.isFull ? "unset" : "250px",
        margin: "6px 0",
        background: "#fff",
        marginRight: "10px",
        width: props.isFull ? "100%" : "auto",
      }}
      className=""
    >
      <input
        onChange={props.onSearch}
        className="email-search"
        style={{
          border: "none",
          width: "82%",
          height: "90%",
          padding: "0 5px",
          color: "#657285",
          fontSize: "14px"
        }}
        placeholder={props.placeholder}
      />
      <ActionSearch
        style={{
          position: "absolute",
          right: "0",
          marginRight: "5px",
          fill: "#6B7c93",
          backgroundColor: "#fff",
        }}
      />
    </div>
  );
};
const DialogTitle = (props) => {
  return (
    <div>
      <div
        style={{
          backgroundColor: "#657285",
          padding: "12px 16px",
          color: "#fff",
          minHeight: "60px",
        }}
        className="d-flex align-center justify-between desktop-address-book"
      >
        <span style={{ fontSize: "15px" }}>{props.heading}</span>
        <div className="flex-center">
          <GroupSelect
            selectedGroup={props.selectedGroup}
            handleGroupSelect={props.handleGroupSelect}
            groups={props.groups}
          />
          <SearchBar placeholder={props.searchPlaceHolder} onSearch={props.onSearch} />
          <Clear
            onClick={props.handleClose}
            style={{
              fill: "#fff",
              cursor: "pointer",
              width: "30px",
              height: "30px",
            }}
          />
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#657285",
          padding: "12px 16px",
          color: "#fff",
          minHeight: "60px",
          flexDirection: "column",
        }}
        className="d-flex align-center justify-between mobile-address-book"
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ fontSize: "15px" }}>{props.heading}</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <GroupSelect
              selectedGroup={props.selectedGroup}
              handleGroupSelect={props.handleGroupSelect}
              groups={props.groups}
              isFull={true}
            />
            <Clear
              onClick={props.handleClose}
              style={{
                fill: "#fff",
                cursor: "pointer",
                width: "30px",
                height: "30px",
              }}
            />
          </div>
        </div>
        <SearchBar placeholder={props.searchPlaceHolder} onSearch={props.onSearch} isFull={true} />
      </div>
    </div>
  );
};

class AddressBookDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGroup: "group",
      addressBook: [],
      // isAllSelected: false,
      selectedIds: [],
      selectedAddress: null,
      showRoleDialog: false,
      role: "",
      showConfirmRole: false,
      hasRoleSelectManual: false,
      selectedSortMethods: {
        name: '',
        email: '',
        role: '',
        group: ''
      }
    };

    this.nameSortMethods = ['numerical', 'alphabetical', 'japanese-syllabary'];
    this.emailSortMethods = ['numerical', 'alphabetical'];
    this.roleSortMethods = ['host', 'participant'];
  }

  componentDidMount() {
    if (this.props.addressBook) {
      this.setState({
        addressBook: this.props.addressBook.map((a) => {
          a.isVisible = true;
          a.isSelected = this.props.selectedAddresses 
          && this.props.selectedAddresses.length > 0 
          && this.props.selectedAddresses.find(add => add.id === a.id) 
            ? true 
            : false;
          return a;
        }),
        showRoleDialog: this.props.role ? false : true,
      }, () => {
        if(this.props.role) {
          this.handleRoleSelect(this.props.role);
        }
        this.setState({ isAllSelected: this.state.addressBook.filter(a => a.isVisible).every(a => a.isSelected)});
      });
    }
  }

  handleGroupSelect = (event, index, value) => {
    let addressBook = this.state.addressBook.map((a) => {
      if (value === "group" && a.role && a.role.split(',').includes(this.state.role)) {
        a.isVisible = true;
        return a;
      }
      a.isVisible = a.group_ids.includes(value.toString()) && a.role && a.role.split(',').includes(this.state.role);
      return a;
    });
    this.setState({ selectedGroup: value, isAllSelected: addressBook.filter(a => a.isVisible).every(a => a.isSelected) });
  };

  handleAllAdressSelect = () => {
    let value = !this.state.isAllSelected;
    let addressBook = this.state.addressBook.map((a) => {
      a.isSelected = a.isVisible ? value : false;
      return a;
    });
    this.setState({ addressBook, isAllSelected: value });
  };

  handleAddressSelect = (address, role) => {
    let addressBook = this.state.addressBook.map((a) => {
      if (a.id === address.id) {
        a.isSelected = !a.isSelected;
      }
      return a;
    });
    this.setState({
      addressBook,
      isAllSelected: addressBook.filter(a => a.isVisible).every((a) => a.isSelected),
      selectedAddress: null
    });
  };

  getGroupName = (address) => {
    if (this.state.selectedGroup === "group") {
      return address.group_names.toString().replace(/,(?=[^\s])/g, ", ") || "-";
    } else {
      let group = this.props.groups.find(
        (g) => g.id === parseInt(this.state.selectedGroup)
      );
      return group.name || "-";
    }
  };

  handleSearch = (e) => {
    let keyword = e.target.value;
    let addressBook = this.state.addressBook;
    addressBook = addressBook.map((a) => {
      if (keyword === "") {
        a.isVisible = true;
        return a;
      } else if (keyword) {
        a.isVisible =
          a.email_address.toLowerCase().includes(keyword.toLowerCase()) ||
          a.name.toLowerCase().includes(keyword.toLowerCase());
      }
      return a;
    });
    this.setState({ addressBook });
  };

  handleDone = () => {
    const selectedAddress = this.state.addressBook.filter((a) => {
      return a.isSelected;
    });
    if (selectedAddress.length > 0) {
      this.props.onDone(selectedAddress, this.state.role);
    }
  };

  handleRoleSelect = (role) => {
    let currentRole = this.state.role;
    if(this.props.role && this.props.role !== role && !this.state.hasRoleSelectManual) {
      this.setState({ showConfirmRole: true });
      return;
    }
    this.setState({ showRoleDialog: false, role, hasRoleSelectManual: false }, () => {
      this.handleRoleChange(currentRole, role);
    });
  }

  handleRoleChange = (oldRole, role) => {
    let addressBook = this.state.addressBook;
    addressBook = addressBook.map(address => {
      address.isVisible = address.role && address.role.split(',').includes(this.state.role);
      if(oldRole && oldRole !== role) {
        address.isSelected = false;
      }
      return address
    });
    this.setState({ addressBook, isAllSelected: addressBook.filter(a => a.isVisible).every(a => a.isSelected) });
  }

  handleRoleConfirmation = (value) => {
    this.setState({ 
      showConfirmRole: false, 
      showRoleDialog: false, 
      hasRoleSelectManual: false,
      role: value 
        ? this.props.role === 'host' 
          ? 'participant' 
          : 'host' 
        : this.props.role 
    }, () => {
      if(value) {
        let addressBook = this.state.addressBook;
        addressBook = addressBook.map(a => {
          a.isSelected = false;
          return a;
        });
        this.setState({ addressBook });
      } 
      this.handleRoleChange();
    });
  }

  getRoles = (role) => {
    let roles = role.split(',');
    if(roles.length === 2) {
      return <span>
        <FormattedMessage id={"emailAddressBook.host"} /><br />
        <FormattedMessage id={"emailAddressBook.participant"} />
      </span>
    } else {
      return <FormattedMessage id={"emailAddressBook." + role} />
    }
  }

  sortAddressBook = (action) => {
    let addressBook = this.state.addressBook;
    if (action.sortType === 'name' || action.sortType === 'email_address') {
      if (action.by === "alphabetical") {
        addressBook = sortAlphabetically(addressBook, action.sortType)
       } else if(action.by === "japanese-syllabary") {
         addressBook = sortByJapaneseSyllabary(addressBook, action.sortType);
       } else if (action.by === "numerical") {
         addressBook = sortNumerically(addressBook, action.sortType)
       }
    } else if (action.sortType === 'role') {
       addressBook = addressBook.sort((a, b) => a.role.includes(action.by) ? -1 : 1);
    }
    this.setState({ addressBook: addressBook });
  }

  getSortMethodsList = (type) => {
    return type === 'name'
      ? this.nameSortMethods
      : type === 'email'
        ? this.emailSortMethods
        : type === 'role'
          ? this.roleSortMethods
          : null;
  }

  handleSort = (type) => {
    const selectedSortMethods = this.state.selectedSortMethods;
    const list = this.getSortMethodsList(type);
    if(list) {
      const selectedIndex = list.findIndex(e => e === selectedSortMethods[type]);
      selectedSortMethods[type] = (selectedIndex === -1 || selectedIndex >= list.length - 1) ? list[0] : list[selectedIndex + 1];
      this.setState({ selectedSortMethods }, () => {
        console.log(this.props, selectedSortMethods[type], type);
        this.sortAddressBook({by: selectedSortMethods[type], sortType: type === 'email' ? 'email_address' : type,});
      });
    }
  }

  render() {
    const actions = [
      <FlatButton
        label={<FormattedMessage id="emailAddressBook.cancel" />}
        labelStyle={{ color: "#858585" }}
        onClick={this.props.handleClose}
      />,
      <FlatButton
        backgroundColor="#60d1bd"
        hoverColor="#60d1bd"
        label={<FormattedMessage id="emailAddressBook.done" />}
        labelStyle={{ color: "#fff" }}
        onClick={this.handleDone}
      />,
      <FlatButton 
        labelStyle={{ color: "#858585", textDecoration: "underline" }}
        label={<FormattedMessage id="emailAddressBook.reselectRole" />}
        onClick={() => this.setState({ showRoleDialog: true, hasRoleSelectManual: true })}
      />
    ];
    const { formatMessage } = this.props.intl;
    let searchPlaceHolder = formatMessage({ id: "emailAddressBook.searchUserName" })
    return (
      <Dialog
        modal={false}
        title={
          <DialogTitle
            heading={
              <FormattedMessage id="loggedInNavigation.emailAddressBook" />
            }
            handleClose={this.props.handleClose}
            groups={this.props.groups}
            selectedGroup={this.state.selectedGroup}
            handleGroupSelect={this.handleGroupSelect}
            onSearch={this.handleSearch}
            searchPlaceHolder={searchPlaceHolder}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "970px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        actions={actions}
        actionsContainerStyle={{
          display: "flex",
          justifyContent: "space-around",
          backgroundColor: "rgb(241, 241, 241)",
          padding: "12px 28px 15px",
        }}
        className="popup-modal"
        bodyClassName="popup-modal-body table-padding"
      >
        <RoleSelect
          handleRoleSelect={this.handleRoleSelect}
          open={this.state.showRoleDialog}
          role={this.props.role}
          closeRoleSelect={this.props.handleClose}
        />
        <ConfirmRole 
          open={this.state.showConfirmRole} 
          role={this.props.role}
          handleRoleConfirmation={this.handleRoleConfirmation}
        />
        <div
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 30px",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <Table
            selectable={false}
            selectedColor="black"
            // height={"70vh"}
            bodyStyle={{
              display: "contents",
            }}
            style={{
              border: "1px solid #b8b8b8",
              marginTop: "8px",
              minWidth: "612px",
            }}
          >
            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn
                  colSpan={1}
                  style={tdStyle}
                  className="flex-center"
                >
                  {this.state.role && <Checkbox
                    iconStyle={{
                      fill: "#fff",
                    }}
                    style={{
                      width: "auto",
                    }}
                    inputStyle={{
                      width: "100%",
                    }}
                    checked={this.state.isAllSelected}
                    onCheck={this.handleAllAdressSelect}
                  />}
                </TableRowColumn>
                <TableRowColumn
                  colSpan={2}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  <TableRowContent label="name" sortAddressBook={this.handleSort} />
                </TableRowColumn>
                <TableRowColumn
                  colSpan={4}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  <TableRowContent label="email" sortAddressBook={this.handleSort} />
                </TableRowColumn>
                <TableRowColumn
                  colSpan={2}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  <TableRowContent label="role" sortAddressBook={this.handleSort} />
                </TableRowColumn>
                <TableRowColumn
                  colSpan={2}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="emailAddressBook.group" />}
                </TableRowColumn>
              </TableRow>

              {(this.state.addressBook.length === 0 || this.state.addressBook.every(a => !a.isVisible)) && (
                <TableRow
                  selected={false}
                  className="light-row"
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={10} style={tdStyle}>
                    <p style={{ color: "#979797" }}>
                      {this.state.addressBook.length === 0 ? <FormattedMessage id="emailAddressBook.noUserInAddressBook" /> : <FormattedMessage id="emailAddressBook.noResultFound" />}
                    </p>
                  </TableRowColumn>
                </TableRow>
              )}

              {this.state.addressBook.map((address, index) => {
                if (address.isVisible) {
                  return (
                    <TableRow
                      key={index}
                      selected={false}
                      className={index % 2 == 0 ? "dark-row" : "light-row"}
                      style={{
                        backgroundColor: "#f2f3f6",
                        borderBottom: "1px solid #b8b8b8",
                      }}
                    >
                      <TableRowColumn style={tdStyle} className="flex-center">
                        <Checkbox
                          iconStyle={{
                            fill: "#657285",
                          }}
                          style={{
                            width: "auto",
                          }}
                          inputStyle={{
                            width: "100%",
                          }}
                          checked={address.isSelected}
                          onCheck={() => this.handleAddressSelect(address, null)}
                        />
                      </TableRowColumn>
                      <TableRowColumn colSpan={2} style={tdStyle}>
                        {address.name}
                      </TableRowColumn>
                      <TableRowColumn colSpan={4} style={tdStyle}>
                        {address.email_address}
                      </TableRowColumn>
                      <TableRowColumn colSpan={2} style={tdStyle}>
                        {this.getRoles(address.role)}
                      </TableRowColumn>
                      <TableRowColumn colSpan={2} style={tdStyle}>
                        {this.getGroupName(address)}
                      </TableRowColumn>
                    </TableRow>
                  );
                }
              })}
            </TableBody>
          </Table>
        </div>
      </Dialog>
    );
  }
}

export default injectIntl(AddressBookDialog);



// WEBPACK FOOTER //
// src/components/Seminars/AddressBookDialog.js